export const NAME_VALIDATOR_REGEX = "^[a-zA-Z0-9 '._-]+$";

export const NAME_VALIDATOR_REGEX_SPACE_ONLY = "^[a-zA-Z0-9 ]+$";
